import { InputForm, SubmitButton, Error, Textarea } from "components";
import { UpdateSingleAuthDataInput, UpdateSingleAuthDataInputError } from "modules/auth/users/store/actionType";
interface FormProps {
  handleSave: (event: React.FormEvent<HTMLButtonElement>) => void;
  formData: UpdateSingleAuthDataInput;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  error: UpdateSingleAuthDataInputError;
  loading: boolean;
  header:string;
  fieldValue:string
}
const ChangeNameForm: React.FC<FormProps> = ({
  formData,
  handleChange,
  error,
  loading,
  handleSave,
  header,
  fieldValue
}) => {
  return (
    <section className="w-full flex flex-col items-center justify-center p-4">
      <form className="w-full max-w-screen-md">
        <h2 className="text-2xl font-bold text-center mb-4">{header}</h2>
        <div className="grid grid-cols-1 gap-3">
          <div>
            <InputForm
              label={`Enter Your ${fieldValue}`}
              type="text"
              id="value"
              name="value"
              value={formData.value}
              onChange={handleChange}
            />
            {error.value && <Error>{error.value}</Error>}
          </div>
          <div>
            <InputForm
              label="Enter Your Password"
              type="text"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
            />
            {error.password && <Error>{error.password}</Error>}
          </div>
        </div>
        <div className="flex items-center justify-between mt-6">
          <SubmitButton loading={loading} onClick={handleSave} />
        </div>
      </form>
    </section>
  );
};
export default ChangeNameForm;
